// Forms Textarea Autosize

import 'textarea-autosize';

$(document).ready(() => {

    $('textarea.autosize-input').textareaAutoSize();

});